import { ArrowRightIcon, FileIcon } from '@radix-ui/react-icons'
import { BaseHubImage } from 'basehub/next-image'

import { useLantern } from '~/hooks/use-lantern'
import { Button } from '~/sotano-kit/primitives/button'
import { Templates } from '../../../dashboard'

type Template = Templates['templates']['items'][number]

export type TemplateSelector = {
  template: Template | null
  onClick: ((template: Template | null) => void) | undefined
}

export const TemplateSelector: React.FC<TemplateSelector> = ({
  template,
  onClick,
}) => {
  const { maskRef, elementRef, focusHandlers } = useLantern<HTMLDivElement>({
    size: 'sm',
  })

  const isBlank = template === null

  return (
    <div ref={elementRef} className="relative">
      <Button
        onClick={() => onClick?.(template)}
        {...focusHandlers}
        type="submit"
        unstyled
        className="enabled:hover:bg-dark-base cursor-default group inline-flex w-full items-center rounded-md border border-dark-border-solid bg-dark-shade p-1 xl:p-[7px] pl-2 xl:pl-3 text-xs font-normal leading-4 outline-none disabled:cursor-not-allowed disabled:border-opacity-40 disabled:bg-opacity-40 [&:disabled_>_:not(.opaque)]:opacity-40"
      >
        <div
          ref={maskRef}
          style={{ ['--opacity' as string]: 0, opacity: 'var(--opacity)' }}
          aria-hidden
          className="opaque absolute top-0 left-0 z-10 inline-flex w-full items-center rounded-md border border-dark-control-base bg-transparent p-1 xl:p-[7px] pl-2 xl:pl-3 text-xs font-normal leading-4 opacity-0 group-disabled:bg-dark-base"
        >
          {isBlank ? (
            <FileIcon width={16} height={16} />
          ) : (
            <BaseHubImage
              src={template.icon.url}
              width={16}
              height={16}
              className="pointer-events-none flex-grow-0 flex-shrink-0 invert dark:invert-0"
              alt={template.icon.alt ?? ''}
            />
          )}
          <span className="mr-auto capitalize ml-2">
            {isBlank ? 'Blank repo' : template._title}
          </span>

          <span className="pointer-events-none rounded border border-dark-border-solid p-1">
            <ArrowRightIcon width={16} height={16} />
          </span>
        </div>

        {isBlank ? (
          <FileIcon width={16} height={16} />
        ) : (
          <BaseHubImage
            src={template.icon.url}
            width={16}
            height={16}
            className="pointer-events-none flex-grow-0 flex-shrink-0 invert dark:invert-0"
            alt={template.icon.alt ?? ''}
          />
        )}
        <span className="mr-auto capitalize ml-2">
          {isBlank ? 'Blank repo' : template._title}
        </span>

        <span className="pointer-events-none rounded border border-dark-border-solid p-1">
          <ArrowRightIcon width={16} height={16} />
        </span>
      </Button>
    </div>
  )
}
